export enum UserRole {
  CCO = 'cco',
  COMPLIANCE_REP = 'compliance_rep',
  DEPARTMENT_REP = 'department_rep',
  ADMIN = 'admin',
}

export type Permission =
  | 'view_all_departments'
  | 'approve_documents'
  | 'bulk_publish'
  | 'manage_reviewers'
  | 'configure_connectors'
  | 'view_audit_trail'
  | 'query_archive'
  | 'manage_tenant';

export interface AuthUser {
  readonly userId: string;
  readonly name: string;
  readonly email: string;
  readonly role: UserRole;
  readonly tenantId: string;
  readonly customerId: string;
  readonly departments: readonly string[];
  readonly permissions: readonly Permission[];
}

export const ROLE_PERMISSIONS: Record<UserRole, readonly Permission[]> = {
  [UserRole.CCO]: [
    'view_all_departments',
    'approve_documents',
    'bulk_publish',
    'manage_reviewers',
    'configure_connectors',
    'view_audit_trail',
    'query_archive',
    'manage_tenant',
  ],
  [UserRole.COMPLIANCE_REP]: [
    'view_all_departments',
    'approve_documents',
    'view_audit_trail',
    'query_archive',
  ],
  [UserRole.DEPARTMENT_REP]: [
    'approve_documents',
  ],
  [UserRole.ADMIN]: [
    'manage_reviewers',
    'configure_connectors',
    'manage_tenant',
  ],
};
